// extracted by mini-css-extract-plugin
export default {"contactless":"dvap_Q","contactlessLabel":"yD9dP4","contactlessLabelNew":"u7EvNz","contactlessToggle":"xSHQC2"};